<div fxLayout="row" fxLayoutAlign="end end">
  <button class="dialog-close-button" mat-mini-fab color="warn" (click)="dialogRef.close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div fxLayout="column" class="policy-container">
  <app-upload-locations (locationsUploaded)="dialogRef.close()"></app-upload-locations>
</div>
